import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from "vuex";
import { LOAD_APPLICATION_FEES, SAVE_APPLICATION_FEES } from "../../../../store/lender-submit-actions";
import FeesCosts from "./fees-costs";
import CalculatedDetails from "./calculated-details";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "Fees",
  components: {
    FeesCosts,
    CalculatedDetails
  },
  props: {
    applicationId: {
      type: Number,
      required: true
    },
    clientUsername: {
      type: String,
      required: true
    }
  },
  mounted() {
    this.loadFees();
  },
  // Since this component is inside a keep-alive block, when coming back since it is already
  // instantiated the mounted hook is not executed, and the information is not refreshed.
  // The activated hook executes when an already instanced component is coming back inside a
  // keep-alive block, see: direct-to-lender/direct-to-lender-container.vue
  activated() {
    this.loadFees();
  },
  methods: _objectSpread(_objectSpread({}, mapActions("ApplicationStore", [LOAD_APPLICATION_FEES, SAVE_APPLICATION_FEES])), {}, {
    handleSaveFees() {
      this.SAVE_APPLICATION_FEES({
        applicationId: this.applicationId,
        clientUsername: this.clientUsername
      });
    },
    loadFees() {
      const {
        clientUsername,
        applicationId
      } = this;
      this.LOAD_APPLICATION_FEES({
        applicationId,
        clientUsername
      });
    }
  })
});